import React, { useEffect } from "react";
import location from "../../assets/img/icons/common/location.png";
import subOrg from "../../assets/img/icons/common/subOrg.png";
import tenant from "../../assets/img/icons/common/tenant.png";
import { StructuralAccountType } from "../../pages/HierachyManagementDashboard/StructuralAccountType";

export default function AccountImage({ structuralAccountTypeId }) {
	const [icon, setIcon] = React.useState("❓");
	const [altText, setAltText] = React.useState("Unknown");

	useEffect(() => {
		switch (structuralAccountTypeId) {
			case StructuralAccountType.Tenant:
				setIcon(tenant);
				setAltText("HQ");
				break;
			case StructuralAccountType.Suborg:
				setIcon(subOrg);
				setAltText("SubOrg");
				break;
			case StructuralAccountType.Location:
				setIcon(location);
				setAltText("Location");
				break;
			default:
				setIcon("❓");
				setAltText("Unknown");
		}
	}, [structuralAccountTypeId]);

	return (
		<img src={icon} alt={altText} className="delete-modal-icon img-fluid" />
	);
}
